// removed by extract-text-webpack-plugin
module.exports = {"description":"login-confirmation-message__description__374IM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/login-confirmation-message.scss
// module id = 1241
// module chunks = 1